import API from '../api'
import postUrl from './paths'

export const createShipmentRequestApi = (shipmentRequest) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createShipmentRequest, shipmentRequest)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const createShipmentRequestSupplyResponseApi = (shipmentRequestId, supplyResponses) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createShipmentRequestSupplyResponse, supplyResponses, { shipmentRequestId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// body is a list of dispatch plans, each shaped like the /shipmentRequest/dispatchPlan/draft response
export const createShipmentDispatchPlansApi = (dispatchPlans) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createShipmentDispatchPlans, dispatchPlans)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const autoCreateShipmentApi = (orderId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.autoCreateShipment, {}, { orderId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
